module.exports = {
  production: true,
  protocol: "https",
  host: "0.0.0.0",
  port: "80",
  api: "https://api.uunn.co.uk",
  authUrl: "https://uunn-backoffice-production.auth.eu-west-1.amazoncognito.com/login?response_type=token&client_id=1443jq12sloh17fd1pvtgetsur&redirect_uri=https://backoffice.uunn.co.uk/login",
  logoutUrl: "https://uunn-backoffice-production.auth.eu-west-1.amazoncognito.com/logout?client_id=1443jq12sloh17fd1pvtgetsur&logout_uri=https://backoffice.uunn.co.uk/login"
};
